import { Box, ListItemButton, Stack, Tooltip, Typography } from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

interface ChatLibraryItemProps {
  chat: ChatAnalyze.SavedChat
  selected: boolean
  onClick: () => void
}

function fraudColor(
  score: number,
): "success.main" | "warning.main" | "error.main" {
  if (score < 30) return "success.main"
  if (score < 60) return "warning.main"
  return "error.main"
}

function chatTypeLabel(type: string): string {
  if (type === "channel") return "Канал"
  if (type === "supergroup" || type === "group") return "Группа"
  return type
}

export function ChatLibraryItem({
  chat,
  selected,
  onClick,
}: ChatLibraryItemProps) {
  const color = fraudColor(chat.latestFraudScore)
  const date = new Date(chat.latestAnalysisDate).toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })

  return (
    <ListItemButton
      selected={selected}
      onClick={onClick}
      sx={{ borderRadius: 1, px: 1.5, py: 1 }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ width: "100%" }}
      >
        <Tooltip
          title={`Fraud score: ${chat.latestFraudScore}`}
          placement="right"
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor: color,
              flexShrink: 0,
            }}
          />
        </Tooltip>
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" noWrap fontWeight={selected ? 600 : 400}>
            {chat.name}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {chat.memberCount.toLocaleString("ru-RU")} уч. · {date}
          </Typography>
        </Stack>
      </Stack>
    </ListItemButton>
  )
}
